<template>
  <div class="project-list-container">
    <div class="mask-content"></div>
    <div class="tree-content">

      <el-autocomplete
        v-model="keyword"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        class="input-with-select"
        @select="handleSelect"
      >
        <template slot-scope="{ item }">
          <div class="name">{{ item.deviceName }}</div>
        </template>
      </el-autocomplete>

      <div class="tree-list">
        <!-- <div
          v-for="item in searchList"
          :key="item.projectId"
          class="search-item"
          @click="changeSearchItem"
        >
          {{ item.deviceName }}
        </div> -->

        <el-tree
          :props="props"
          :load="loadNode"
          lazy
          ref="elTree"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>

      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="changeProject">确认</el-button>
    </div>
  </div>
</template>
<script>
import {
  getProject,
  getProjectDevices,
  getMyDevice,
} from "@/libs/src/providers/apis/project.js";

export default {
  data() {
    return {
      props: {
        label: "name",
        children: "zones",
        isLeaf: "leaf",
      },
      keyword: "桥头",
      count: 1,
      projectList: [],
      userinfo: {},
      showProjectList: false,
      searchList: [],
    };
  },
  computed: {},
  async beforeCreate() {},
  methods: {
    async querySearchAsync(queryString, cb) {
      let data = await getMyDevice(this.userinfo.groupId, queryString);
      console.log(data);
      cb(data.data || []);
    },
    handleSelect(item) {
      this.keyword = item.deviceName
      this.$Auth.device = item;
      this.$emit("change", item);
    },

    cancel() {
      this.$emit("close");
    },
    changeProject() {
      console.log(this.device);
      if (this.device) {
        // storage.set("device", this.device);
        this.$Auth.device = this.device;
        this.$emit("change", this.device);
        // window.location.href = '/'
      }
    },
    handleNodeClick(data) {
      let deviceNo = data.deviceNo;
      if (deviceNo) {
        this.device = data;
      }
    },
    async initProject(groupId) {
      return new Promise((resolve) => {
        getProject(groupId, (data) => {
          this.projectList = data.data;
          resolve(data.data);
        });
      });
    },
    async initDevices(groupId, projectID) {
      return new Promise((resolve) => {
        getProjectDevices(groupId, projectID, (data) => {
          resolve(data.data);
        });
      });
    },
    async loadNode(node, resolve) {
      this.userinfo = this.$Auth.userInfo; // await storage.get("userinfo");
      let projectList = await this.initProject(this.userinfo.groupId);
      let tree = [];
      for (let i = 0; i < projectList.length; i++) {
        let obj = Object.assign({ children: [] }, projectList[i]);
        tree.push(obj);
      }
      if (node.level === 0) {
        return resolve(tree);
      }
      if (node.level == 1) {
        let device = await this.initDevices(
          this.userinfo.groupId,
          node.data.id
        );
        device.map((obj) => {
          obj.children = [];
          obj.name = obj.deviceName;
          obj.leaf = true;
        });
        return resolve(device);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.project-list-container {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  .mask-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .tree-content {
    position: relative;
    width: 600px;
    height: 80%;
    margin: auto;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    padding: 20px;
    box-sizing: border-box;
    .tree-list {
      height: 90%;
      overflow: auto;
      margin-bottom: 15px;
    }
  }
  .search-item {
    padding: 5px;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
    }
    &.active {
      background: rgba(0, 0, 0, 0.5);
    }
  }
  .input-with-select {
    width: 100%;
  }
}
</style>